import getters from "./getters"
import actions from "./actions"
import mutations from "./mutations"
import cacheLs from "../cacheLs"

const state = {
  selectedWelcome: cacheLs.get_welcome()
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
